import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children, requireOnboarded = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-center text-[#6B6B6B]">Caricamento…</div>;
  if (!user) return <Navigate to="/accedi" replace />;
  if (requireOnboarded && !user.onboarded) return <Navigate to="/onboarding" replace />;
  return children;
}
